export const SENSORS_PREFIX = "sensors";

export const SENSORS_ACTIONS = {
  GET_SENSOSRS: `${SENSORS_PREFIX}/GET_SENSORS`,
} as const;
